import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Grid } from '@material-ui/core'
import { useSelector, useDispatch } from 'react-redux'

import Filters from '../filters'
import Graphics from '../graphics'
import { useStyles } from './styles'
import SummaryCards from '../summaryCards'
import Loading from '../../common/Loading/index'
import { products } from '../../../constants/production-panel'
import { getLast30DaysFromToday, getTodayDate } from '../../../utils/dates'
import { createQuerySummaryCards } from '../../../utils/productionPanel'
import { getControlPanelData } from '../../../api/controlPanel'
import { setExportQuery, setDeactivateFilterFlag } from '../../../store/actions/controlPanel'
import { setHandleAlert } from '../../../store/actions/common'

const LayoutProductionPanel = ({ userData }) => {
  const dispatch = useDispatch()
  const classes = useStyles()
  const { oil, water, gas } = products
  const [currentTenantId, setCurrentTenantId] = useState(0)
  const [loading, setLoading] = useState(false)
  const [controlPanelData, setControlPanelData] = useState(null)

  const selectedSitesFilter = useSelector(
    (state) => state.controlPanel.selectedSitesFilter
  )
  const selectedAssetsFilter = useSelector(
    (state) => state.controlPanel.selectedAssetsFilter
  )
  const dateRangeFilter = useSelector((state) => state.controlPanel.dateRange)
  const productsFilter = useSelector((state) => state.controlPanel.products)
  const activateFilterFlag = useSelector(
    (state) => state.controlPanel.activateFilterFlag
  )

  /* Config initial request summary - FIlters */
  const defaultProductsList = [oil.value, water.value, gas.value]
  const defaultFromDate = getLast30DaysFromToday()
  const defaultToDate = getTodayDate('YYYY-MM-DD')
  /* End config initial request summary - FIlters */

  useEffect(() => {
    if (userData.accessToken && userData.tenantId) {
      if (currentTenantId !== userData.tenantId)
      {
        setCurrentTenantId(userData.tenantId)
        dispatch(setDeactivateFilterFlag())
      } else {
        getDataControlPanelFunction()
      }
    }
  }, [userData.accessToken, userData.tenantId])

   useEffect(() => {
    if (userData.accessToken && userData.tenantId) {
      getDataControlPanelFunction()
    }
  }, [activateFilterFlag])

  const verifyDatesAndProducts = () => {
    const [fromDate, toDate] =
      dateRangeFilter.length == 2
        ? dateRangeFilter
        : [defaultFromDate, defaultToDate]

    const productsList =
      productsFilter.length >= 1 ? productsFilter : defaultProductsList

    return { fromDate, toDate, productsList }
  }

  const createQuery = () => {
    const { fromDate, toDate, productsList } = verifyDatesAndProducts()
    let filterQuery = createQuerySummaryCards(
      selectedSitesFilter,
      selectedAssetsFilter,
      fromDate,
      toDate,
      productsList
    )

    dispatch(setExportQuery(filterQuery))
    return filterQuery
  }

  const getDataControlPanelFunction = () => {
    setLoading(true)
    let filterQuery = createQuery()

    getControlPanelData(userData.accessToken, userData.tenantId, filterQuery)
      .then((response) => {
        if (response.status >= 200 && response.status <= 299) {
          setControlPanelData(response.data)
          setLoading(false)
        }
      })
      .catch((error) => {
        showAlertMessage(error?.response?.data, true, 'error')
        setLoading(false)
      })
  }

  const showAlertMessage = (message, status, severity) => {
    dispatch(
      setHandleAlert({
        message,
        status,
        severity,
      })
    )
  }

  return (
    <div className={classes.root}>
      <Grid>
        <Filters />
        {!loading ? (
          <>
            <SummaryCards controlPanelData={controlPanelData || []} />
            <Graphics controlPanelData={controlPanelData || []} />
          </>
        ) : (
          <Loading />
        )}
      </Grid>
    </div>
  )
}

const mapPropsFromState = ({ multitenantUser, controlPanel }) => ({
  userData: {
    accessToken: multitenantUser.accessToken,
    tenantId: multitenantUser.tenants?.find((t) => t.selected)?.id || 0,
  },
  controlPanel
})

export default connect(mapPropsFromState)(LayoutProductionPanel)
